import AuthService from './authService';

function getCurrentUserInfo() {
    return AuthService.getLoginInfo();
}

function checkIfUserIsLoggedIn() {
    return AuthService.isLoginValid();
}

function performActionRequiringLogin() {
    const userInfo = getCurrentUserInfo();
    if (!userInfo) {
        console.log('用户未登录或登录信息已过期');
        return false;
    }

    console.log(`执行操作，当前用户为: ${userInfo.username}`);
    return true;
}

// 导出函数以便其他地方可以使用
export {
    getCurrentUserInfo,
    checkIfUserIsLoggedIn,
    performActionRequiringLogin
};